import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Spacer } from 'design-system';
import IconStatusPaused from 'design-system/icons/status/IconStatusPaused';
import IconStatusPending from 'design-system/icons/status/IconStatusPending';
import StatusIcon from 'design-system/StatusIcon';
import Text from 'design-system/Text';
import useColors from 'hooks/useColors';
import { assertUnreachable } from 'utils';
const AutosaveActivityStatusView = ({ status, ...props }) => {
    const colors = useColors();
    if (status === 'COMPLETED') {
        return (<View style={styles.row} {...props}>
        <View style={styles.flex}>
          <View style={styles.row}>
            <StatusIcon height={16} width={16} state="done"/>
            <Spacer w={8}/>
            <View style={styles.flex}>
              <Text TextThin-14 Green numberOfLines={1}>
                Completed
              </Text>
            </View>
          </View>
        </View>
      </View>);
    }
    if (status === 'FAILED' || status === 'FAILED_BELOW_THRESHOLD' || status === 'FAILED_OB_CONNECTION') {
        return (<View style={styles.row} {...props}>
        <View style={styles.flex}>
          <View style={styles.row}>
            <StatusIcon height={16} width={16} state="cancelled-red"/>
            <Spacer w={8}/>
            <View style={styles.flex}>
              <Text TextThin-14 Negative numberOfLines={1}>
                Cancelled
              </Text>
            </View>
          </View>
        </View>
      </View>);
    }
    if (status === 'SKIPPED') {
        return (<View style={styles.row} {...props}>
        <View style={styles.flex}>
          <View style={styles.row}>
            <IconStatusPaused width={16} height={16} colorKey="secondary" color={colors.cards.onDark} bgColor={colors.elements.secondary}/>
            <Spacer w={8}/>
            <View style={styles.flex}>
              <Text TextThin-14 Secondary numberOfLines={1}>
                Skipped
              </Text>
            </View>
          </View>
        </View>
      </View>);
    }
    if (status === 'PENDING') {
        return (<View style={styles.row} {...props}>
        <View style={styles.flex}>
          <View style={styles.row}>
            <IconStatusPending width={16} height={16} color={colors.cards.onDark} bgColor={colors.elements.statusInformational}/>

            <Spacer w={8}/>
            <View style={styles.flex}>
              <Text TextThin-14 StatusInformational numberOfLines={1}>
                Pending
              </Text>
            </View>
          </View>
        </View>
      </View>);
    }
    // doesnt get here;
    assertUnreachable(status);
    return null;
};
export default AutosaveActivityStatusView;
const styles = StyleSheet.create({
    row: {
        alignItems: 'center',
        flexDirection: 'row',
    },
    flex: {
        flex: 1,
    },
});
